/* Keep sample-request buttons on the native form when page builders republish. */
(() => {
  'use strict';
  const destination = '/pages/request-testpacks';
  const oldPaths = new Set([
    '/pages/request-testpacks-and-printed-materials',
    '/pages/testpacks'
  ]);
  const hosts = new Set([
    location.hostname,
    'intoleran.com.au', 'www.intoleran.com.au',
    'intoleran.com', 'www.intoleran.com',
    'disolut-australia.myshopify.com'
  ]);
  const cleanPath = path => path.replace(/\/+$/, '').toLowerCase();

  if (oldPaths.has(cleanPath(location.pathname))) {
    location.replace(destination);
    return;
  }

  function repairLink(link) {
    if (!link || link.nodeType !== 1 || !link.matches('a[href]')) return;
    let url;
    try { url = new URL(link.getAttribute('href'), document.baseURI); }
    catch (_) { return; }
    if ((url.protocol === 'https:' || url.protocol === 'http:') &&
        hosts.has(url.hostname) && oldPaths.has(cleanPath(url.pathname))) {
      link.setAttribute('href', destination);
    }
  }

  function repairTree(root) {
    if (!root || !root.querySelectorAll) return;
    repairLink(root);
    root.querySelectorAll('a[href]').forEach(repairLink);
  }

  function start() {
    repairTree(document);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') repairLink(record.target);
        else record.addedNodes.forEach(repairTree);
      });
    }).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['href']
    });
  }

  // Capture activation too, including links rendered inside open shadow roots.
  ['click', 'auxclick', 'contextmenu'].forEach(type => {
    document.addEventListener(type, event => {
      event.composedPath().forEach(repairLink);
    }, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
